import { type DatasetImage } from "../api";

// `workflow_status` table ids — global reference data, identical in every
// region. Mirrors apps/global-api's `WorkflowStatus` enum; only the
// superverified ids are needed here — the row icons count superverified
// positives/negatives only, not the plain (non-super) True/False Positive
// statuses.
export const SUPERVISOR_APPROVED = 3;
export const SUPER_FALSE_POSITIVE = 5;

// Statuses the unsuperverify endpoint reverts (to True Positive / False
// Positive respectively) — see apps/global-api's unsuperverify_image.
export const SUPERVISOR_VERIFIED_STATUSES = new Set([
  SUPERVISOR_APPROVED,
  SUPER_FALSE_POSITIVE,
]);

// True when the image carries at least one Supervisor Approved detection.
export function imageHasTruePositive(image: DatasetImage): boolean {
  return image.type_x_workflow_status.some(
    ([, status]) => status === SUPERVISOR_APPROVED,
  );
}

// True when the image carries at least one Supervisor False Positive
// detection, independent of whether it also has a true positive.
export function imageHasFalsePositive(image: DatasetImage): boolean {
  return image.type_x_workflow_status.some(
    ([, status]) => status === SUPER_FALSE_POSITIVE,
  );
}
